module.exports = __webpack_public_path__ + "assets/img/marine.ea0df87a.png";